import { apiClient } from '../config';

export interface ServiceHealth {
  name: string;
  status: 'healthy' | 'degraded' | 'unhealthy' | 'unknown';
  latency_ms?: number;
  details?: Record<string, any>;
  checked_at: string;
}

export interface SystemHealthResponse {
  overall_status: 'healthy' | 'degraded' | 'unhealthy';
  services: ServiceHealth[];
  checked_at: string;
}

export interface ProcessingApiHealth {
  status: 'healthy' | 'degraded' | 'unhealthy' | 'unknown';
  version?: string;
  ffmpeg_available?: boolean;
  uptime_seconds?: number;
  jobs_processed?: number;
  jobs_in_queue?: number;
  latency_ms?: number;
  url?: string;
  error?: string;
  message?: string;
  checked_at: string;
}

export class SystemService {
  // Get overall system health (all services)
  static async getSystemHealth(): Promise<SystemHealthResponse> {
    const response = await apiClient.get<SystemHealthResponse>('/api/system/health');
    return response.data;
  }

  // Get Processing API health details
  static async getProcessingHealth(): Promise<ProcessingApiHealth> {
    const response = await apiClient.get<ProcessingApiHealth>('/api/system/processing');
    return response.data;
  }
}
